import { render, staticRenderFns } from "./user-avatar.component.vue?vue&type=template&id=7dbe01b2"
import script from "./user-avatar.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./user-avatar.component.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports